export default __webpack_public_path__ + "static/media/bus-station.3cdd4dd1.svg";